import { render, staticRenderFns } from "./DetailClinic.vue?vue&type=template&id=3f557cf8&scoped=true&"
import script from "./DetailClinic.vue?vue&type=script&lang=js&"
export * from "./DetailClinic.vue?vue&type=script&lang=js&"
import style0 from "./DetailClinic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailClinic.vue?vue&type=style&index=1&id=3f557cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f557cf8",
  null
  
)

export default component.exports